export default "__VITE_ASSET__ee72e99f__"